/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import nodeLogo from '@/assets/temperature-control.png'

function EnvSensorNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={nodeLogo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Env Sensor</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default EnvSensorNode
